/* eslint-disable import/no-default-export */
import {
  render,
  unmountComponentAtNode,
  findDOMNode,
  createPortal,
} from './src/react-dom-wrapper';

export {
  render,
  unmountComponentAtNode,
  findDOMNode,
  createPortal,
} from './src/react-dom-wrapper';

export default {
  render,
  unmountComponentAtNode,
  findDOMNode,
  createPortal,
};
